<div class="search-filter-dropdown-menu {{searchViewClass}}">
  <button
    class="search-filter-dropdown-menu__button"
    mat-stroked-button
    [matMenuTriggerFor]="smallFilterMenu"
    [matMenuTriggerRestoreFocus]="false"
    (menuOpened)="dropdownMenu = true;"
    (menuClosed)="dropdownMenu = false;"
    [matBadge]="checkedFilterCount"
    [ngClass]="{'active': dropdownMenu}"
  >
    <mat-icon class="search-filter-dropdown-menu__button-icon">
      filter_alt
    </mat-icon>

    <span class="search-filter-dropdown-menu__button-text-container">
      <span class="search-filter-dropdown-menu__button-text">
        {{ 'TRANS__FILTER__FILTRATE' | translate }}
      </span>
    </span>

    @if (searchViewClass === 'content-list') {
      <mat-icon class="search-filter-dropdown-menu__button-arrow">
        {{dropdownMenu ? 'expand_less' : 'expand_more'}}
      </mat-icon>
    }
  </button>

  <mat-menu
    class="removePaddingInMatMenu"
    #smallFilterMenu="matMenu"
    [overlapTrigger]="false"
    (closed)="dropdownMenu = false;"
  >
    <app-search-filter-menu
      (click)="$event.stopPropagation()"
      (keydown)="null"
      [dropdownMenu]="dropdownMenu"
      [sideMenu]="false"
      [searchContainer]="searchContainer"
    ></app-search-filter-menu>
  </mat-menu>
</div>
